import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, Grid, LL_H_C, ModuleFE_Thunderstorm, SimpleListAdapter, TS_DropDown, TS_PropRenderer, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import { QScrollWrapper } from '@app/hcs-frontend';
import './Editor_Organization_LaunchUrls.scss';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { ViewKey_Edit, ViewKey_View } from '../../../consts.js';
import { QuaiEnv_LabelMap, QuaiEnvironments } from '@app/org-shared';
import { ModuleFE_Environment } from '../../../../../_entity/installation/environment/index.js';
import { ModuleFE_Facility } from '../../../../../_entity/installation/facility/index.js';
import { ModuleFE_EHRInstallation } from '../../../../../_entity/installation/ehr-installation/index.js';
import { ModuleFE_Organization } from '../../../../../_entity/organization/index.js';
import { ModuleFE_LaunchUrls } from '../../../../../_entity/launch-urls/index.js';
import { ModuleFE_ShortUrl } from '@nu-art/ts-short-url-frontend';
export class Editor_Organization_LaunchUrls extends TS_EditableItemComponentProto {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        state.selectedEnvironment = ModuleFE_Environment.cache.unique(state.editable.item.environmentId);
        state.selectedFacility = ModuleFE_Facility.cache.unique(state.editable.item.facilityId);
        state.selectedQuaiEnv = state.editable.item.quaiEnv;
        state.launchUrlTitle = state.editable.item.label;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewKey_Edit : ViewKey_View;
    getTabs = () => {
        return [{
                uid: 'launch-urls',
                title: 'Launch URLs',
                content: this.renderForm,
            }];
    };
    // ######################## Render ########################
    render() {
        return _jsx(LL_H_C, { id: 'editor-organization-launch-urls', children: this.renderTabs() });
    }
    // ######################## Render - All Tabs ########################
    renderTabs = () => {
        if (!this.state.editable)
            return;
        return _jsx(TS_Tabs, { tabs: this.getTabs() });
    };
    // ######################## Render - URLs Editor ########################
    renderForm = () => {
        if (!this.state.editable)
            return _jsx(_Fragment, {});
        const className = _className(this.state.editMode && 'edit-mode');
        return (_jsx("div", { className: "form-wrapper", children: _jsx(QScrollWrapper, { children: _jsxs(Grid, { className: className, children: [this.renderSaveButton(), this.renderLabel(), this.renderDescription(), this.renderEnvironment(), this.renderInstallation(), this.renderQuaiEnv(), this.renderFacility(), this.renderShortURL(), this.renderFullUrl()] }) }) }));
    };
    renderSaveButton = () => {
        const { editable, selectedEnvironment, selectedQuaiEnv } = this.state;
        if (!editable || editable?.item._id)
            return;
        const disabled = !(selectedEnvironment && selectedQuaiEnv && editable.item.description && editable.item.label);
        return _jsxs(_Fragment, { children: [_jsx(Button, { disabled: disabled, variant: 'primary', onClick: async () => {
                        try {
                            await editable?.save();
                        }
                        catch (err) {
                            this.logError(err);
                            this.forceUpdate();
                        }
                    }, children: "Save" }), _jsx("div", {})] });
    };
    renderLabel = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Label', error: editable?.hasError('label'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: editable?.item.label }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'label', value: this.state.launchUrlTitle, onChange: async (newTitle) => {
                                await editable?.updateObj({ label: newTitle });
                                this.reDeriveState({ launchUrlTitle: newTitle });
                            } })
                    }
                ] }) });
    };
    renderEnvironment = () => {
        const selectedEnvironment = this.state.selectedEnvironment;
        const environments = ModuleFE_Environment.cache.all().filter(env => {
            const organizationId = this.props.organizationId;
            const installation = ModuleFE_EHRInstallation.cache.unique(env.ehrInstallationId);
            if (!installation)
                return false;
            return installation.organizationId === organizationId;
        }) ?? [];
        const adapter = SimpleListAdapter(environments, env => {
            const installation = (ModuleFE_EHRInstallation.cache.unique(env.item.ehrInstallationId));
            const installationName = installation?.label ?? 'Unknown Installation';
            const organizationName = (ModuleFE_Organization.cache.unique(installation?.organizationId))?.alias ?? 'Unknown Organization';
            return _jsxs(_Fragment, { children: [organizationName, " - ", installationName, " - ", env.item.label] });
        });
        return _jsx(TS_PropRenderer.Flat, { label: 'Environment', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: selectedEnvironment?.label }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_DropDown, { adapter: adapter, selected: selectedEnvironment, onSelected: async (selectedEnvironment) => {
                                await this.state.editable?.updateObj({ environmentId: selectedEnvironment._id });
                                this.reDeriveState({ selectedEnvironment });
                            } })
                    }
                ] }) });
    };
    renderFacility = () => {
        const selectedFacility = this.state.selectedFacility;
        const facilities = ModuleFE_Facility.cache.all().filter(facility => facility.organizationId === this.props.organizationId) ?? [];
        const adapter = SimpleListAdapter(facilities, facility => _jsx(_Fragment, { children: facility.item.name }));
        return _jsx(TS_PropRenderer.Flat, { label: 'Facility', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: selectedFacility?.name ?? '-' }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_DropDown, { adapter: adapter, selected: selectedFacility, onSelected: async (selectedFacility) => {
                                await this.state.editable?.updateObj({ facilityId: selectedFacility._id });
                                this.reDeriveState({ selectedFacility });
                            } })
                    }
                ] }) });
    };
    renderQuaiEnv = () => {
        const selectedQuaiEnv = this.state.selectedQuaiEnv;
        const adapter = SimpleListAdapter(QuaiEnvironments, item => _jsx(_Fragment, { children: QuaiEnv_LabelMap[item.item] }));
        return _jsx(TS_PropRenderer.Flat, { label: 'Quai Environment', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: QuaiEnv_LabelMap[selectedQuaiEnv] }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(TS_DropDown, { adapter: adapter, selected: selectedQuaiEnv, onSelected: async (selectedQuaiEnv) => {
                                await this.state.editable?.updateObj({ quaiEnv: selectedQuaiEnv });
                                this.reDeriveState({ selectedQuaiEnv });
                            } })
                    }
                ] }) });
    };
    renderInstallation = () => {
        const selectedEnvironment = this.state.selectedEnvironment;
        if (!selectedEnvironment)
            return;
        const installation = ModuleFE_EHRInstallation.cache.unique(selectedEnvironment.ehrInstallationId);
        return _jsx(TS_PropRenderer.Flat, { label: 'Installation', children: _jsx("div", { className: 'grid-data', children: `${installation?.label} (based on environment)` }) });
    };
    renderDescription = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Flat, { label: 'Description', error: editable?.hasError('description'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    { key: ViewKey_View, renderer: () => _jsx("div", { className: 'grid-data', children: editable?.item.description }) },
                    {
                        key: ViewKey_Edit,
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: editable, prop: 'description' })
                    }
                ] }) });
    };
    renderShortURL = () => {
        const editable = this.state.editable;
        const selectedShortURLId = editable.item.shortUrlId;
        const selectedShortURL = ModuleFE_ShortUrl.cache.unique(selectedShortURLId);
        const nonAvailableShortURLs = ModuleFE_LaunchUrls.cache.all()
            .filter(launchURL => launchURL.shortUrlId)
            .map(url => url.shortUrlId);
        const shortURLs = ModuleFE_ShortUrl.cache.all().filter(shortURL => !nonAvailableShortURLs.includes(shortURL._id));
        const adapter = SimpleListAdapter(shortURLs, shortURL => _jsx(_Fragment, { children: shortURL.item._shortUrl }));
        const viewShortURL = _jsx("div", { onClick: () => selectedShortURL?._shortUrl && ModuleFE_Thunderstorm.copyToClipboard(selectedShortURL?._shortUrl), className: 'grid-data', children: `${selectedShortURL?._shortUrl} - ${selectedShortURL?.title} (${selectedShortURLId})` });
        return _jsx(TS_PropRenderer.Flat, { label: 'Short URL', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewKey_View,
                        renderer: () => viewShortURL
                    },
                    {
                        key: ViewKey_Edit,
                        renderer: () => !selectedShortURLId ? _jsx(TS_DropDown, { adapter: adapter, selected: selectedShortURL, onSelected: async (selectedShortUrl) => {
                                await editable?.updateObj({ shortUrlId: selectedShortUrl._id });
                                this.setState({ launchUrlTitle: selectedShortUrl.title });
                            } }) : viewShortURL
                    }
                ] }) });
    };
    renderFullUrl = () => {
        const shortURLId = this.state.editable.item.shortUrlId;
        const fullUrl = ModuleFE_ShortUrl.cache.unique(shortURLId)?.fullUrl;
        if (!fullUrl)
            return;
        return _jsx(TS_PropRenderer.Flat, { label: 'Full URL', children: _jsx("div", { onClick: () => ModuleFE_Thunderstorm.copyToClipboard(fullUrl), className: 'grid-data', children: `${fullUrl}` }) });
    };
}
//# sourceMappingURL=Editor_Organization_LaunchUrls.js.map